<template lang="pug">
//- INFO: `camera` prop works only on non-dev enviroments (!$dev) that are mobile devices ($isTablet, $isMobile)
//- `$dev` and `production on desktops` will resolve to default camera. These are physical PCs, we cannot enforce camera.
qrcode-stream(v-if="$dev" @decode="onDecode" @init="onInit")
qrcode-stream(v-else-if="$isMobile" :camera="'rear'" @decode="onDecode" @init="onInit")
qrcode-stream(v-else-if="$isTablet" :camera="'front'" @decode="onDecode" @init="onInit")
qrcode-stream(v-else @decode="onDecode" @init="onInit")
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  components: { QrcodeStream },
  data() {
    return {
      error: '',
      // camera: 'front' // 'rear' - orginal names: 'user' / 'enviroment'
    }
  },
  methods: {
    onDecode(result) {
      this.$emit('onDecode', result)
    },

    async onInit(promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = 'ERROR: you need to grant camera access permisson'
          this.$errorHumanized(null, 'ERROR: you need to grant camera access permisson')
        } else if (error.name === 'NotFoundError') {
          this.error = 'ERROR: no camera on this device'
          this.$errorHumanized(null, 'ERROR: no camera on this device')
        } else if (error.name === 'NotSupportedError') {
          this.error = 'ERROR: secure context required (HTTPS, localhost)'
        } else if (error.name === 'NotReadableError') {
          this.error = 'ERROR: is the camera already in use?'
          this.$errorHumanized(null, 'ERROR: is the camera already in use?')
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'ERROR: installed cameras are not suitable'
          this.$errorHumanized(null, 'ERROR: installed cameras are not suitable')
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'ERROR: Stream API is not supported in this browser'
          this.$errorHumanized(null, 'ERROR: Stream API is not supported in this browser')
        }
      }
    },
  },
}
</script>

<style scoped>
/* .error {
  font-weight: bold;
  color: red;
} */
</style>
